export enum MultiFunctionalButtonState {
    FEATURE_BUY = 'FeatureBuy',
    FREESPINS_LEFT = 'FreespinsLeft',
    INVISIBLE = 'Invisible'
}
